import instance from "../Api/Instance";
import { back } from "../Api/ApiUrl";
import { useState } from "react";

import {
  fetchShipmentsList,
  fetchShipmentsListForExport,
  fetchSingleShipmentDetail,
  requestShipmentPod,
  requestSearchOptions,
} from "./useShipmentsApi";

export default function useShipments() {
  const [shipmentData, setShipmentData] = useState({
    status: "loading",
    data: [],
    statusCode: 0,
    message: "Cargando...",
    size: 10,
    page: 1,
    totalResults: 0,
    totalPages: 0,
  });

  const [singleShipmentData, setSingleShipmentData] = useState({
    file: null,
    standAlone: false,
    statusCode: 0,
    message: "Cargando...",
    status: "loading",
    telemetryTypeCode: null,
    imei: null,
    macMando: null,
    numRefClient: null,
    destinationData: {},
  });

  const [telemetryInfo, setTelemetryInfo] = useState({
    full: {
      warnings: {
        warningsImpact: 0,
        warningsOpen: 0,
        warningsTemp: 0,
        warningsHum: 0,
      },
    },
    reduced: {
      warnings: {
        warningsImpact: 0,
        warningsOpen: 0,
        warningsTemp: 0,
        warningsHum: 0,
      },
    },
    statusCode: 0,
  });

  const [alertsListInfo, setAlertsListInfo] = useState({
    full: {
      tempMax: 0,
      tempMin: 0,
      alertsList: [],
      configTempMax: null,
      configTempMin: null,
    },
    reduced: {
      tempMax: 0,
      tempMin: 0,
      alertsList: [],
      configTempMax: null,
      configTempMin: null,
    },
    statusCode: 0,
  });

  const [chartsInfo, setChartsInfo] = useState({
    telemetryInfo: {
      full: [],
      reduced: [],
    },
    events: [],
    periodMinuteGuard: 0,
    tempMax: 0,
    tempMin: 0,
    statusCode: 0,
  });

  const [eventsInfo, setEventsInfo] = useState({
    steps: [],
    current: 0,
    statusCode: 0,
    message: "",
  });

  const [searchOptions, setSearchOptions] = useState({
    status: "loading",
    data: [],
    statusCode: 0,
    message: "Cargando...",
  });

  const singleShipmentSetters = {
    setSingleShipmentData,
    setTelemetryInfo,
    setAlertsListInfo,
    setChartsInfo,
    setEventsInfo,
  };

  const fetchShipments = (
    shipmentCode,
    imei,
    numRefClient,
    start,
    end,
    clientNumber,
    labellerCode,
    boxType,
    temperatureTrazability,
    temperatureRange,
    size = 10,
    page = 1,
    pagination = false,
  ) =>
    fetchShipmentsList(instance, back, setShipmentData, setTelemetryInfo, {
      shipmentCode,
      imei,
      numRefClient,
      start,
      end,
      clientNumber,
      labellerCode,
      boxType,
      temperatureTrazability,
      temperatureRange,
      size,
      page,
      pagination,
    });

  const fetchShipmentsForExport = (params) =>
    fetchShipmentsListForExport(instance, back, params);

  const fetchSingleShipment = (shipmentCode) =>
    fetchSingleShipmentDetail(
      instance,
      back,
      shipmentCode,
      singleShipmentSetters,
    );

  const fetchShipmentPod = (shipmentCode) =>
    requestShipmentPod(instance, back, shipmentCode);

  const getSearchOptions = () =>
    requestSearchOptions(instance, back, setSearchOptions);

  return {
    shipmentData,
    singleShipmentData,
    fetchShipments,
    fetchShipmentsForExport,
    fetchSingleShipment,
    telemetryInfo,
    alertsListInfo,
    chartsInfo,
    eventsInfo,
    fetchShipmentPod,
    getSearchOptions,
    searchOptions,
  };
}
